import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_STAGES_PROGRESS].GET_REPORTS_STAGES_PROGRESS]: {
		url: '/company/:companyId/reports/stages/progress/',
	},
}
